import {
  AnalysisReportEntry,
  Campaign,
  Experiment,
  ExperimentAnalysisConfigView,
  ExperimentAvailability,
  InterferenceView,
  MessageTemplate,
  Rollout,
  RolloutHistory,
  VariableInfo,
  VariableStatsView,
} from '../../../lib/PlannerDTOs';
import { State } from '../../../store/state';

export const entitiesSelector = (state: State) => state.entities!;

interface ExperimentMap {
  [key: string]: Experiment;
}

interface VariableMap {
  [key: string]: VariableInfo;
}

interface RolloutMap {
  [key: string]: Rollout;
}

interface RolloutHistoryMap {
  [key: string]: RolloutHistory;
}

interface MessageTemplatesMap {
  [key: string]: MessageTemplate;
}

interface CampaignsMap {
  [key: string]: Campaign;
}

interface VarableStatsMap {
  [key: string]: VariableStatsView;
}

interface InterferenceMap {
  [key: string]: InterferenceView;
}

interface AnalysisConfigMap {
  [key: string]: ExperimentAnalysisConfigView;
}

interface ExperimentAvailabilityMap {
  [key: string]: ExperimentAvailability;
}

interface AnalysisReportMap {
  [key: string]: AnalysisReportEntry;
}

export const experimentEntitiesSelector = (state: State): ExperimentMap =>
  entitiesSelector(state).experiments as ExperimentMap;

export const variableEntitiesSelector = (state: State): VariableMap =>
  entitiesSelector(state).variables as VariableMap;

export const rolloutEntitiesSelector = (state: State): RolloutMap =>
  entitiesSelector(state).rollouts as RolloutMap;

export const rolloutHistoryEntitiesSelector = (
  state: State,
): RolloutHistoryMap =>
  entitiesSelector(state).rolloutHistory as RolloutHistoryMap;

export const messageEntitiesSelector = (state: State): MessageTemplatesMap =>
  entitiesSelector(state).messageTemplates as MessageTemplatesMap;

export const campaignEntitiesSelector = (state: State): CampaignsMap =>
  entitiesSelector(state).campaigns as CampaignsMap;

export const variableStatsEntitiesSelector = (state: State): VarableStatsMap =>
  entitiesSelector(state).variableStats as VarableStatsMap;

export const interferenceEntitiesSelector = (state: State): InterferenceMap =>
  entitiesSelector(state).interferences as InterferenceMap;

export const analysisConfigEntitiesSelector = (
  state: State,
): AnalysisConfigMap =>
  entitiesSelector(state).analysisConfigs as AnalysisConfigMap;

export const expAvailabilityEntitiesSelector = (
  state: State,
): ExperimentAvailabilityMap =>
  entitiesSelector(state).availability as ExperimentAvailabilityMap;

export const analysisReportEntitiesSelector = (
  state: State,
): AnalysisReportMap =>
  entitiesSelector(state).analysisReport as AnalysisReportMap;
